import { api_fetch } from "./client"

export interface StordConfig {
  configured: boolean
  has_api_key: boolean
  stord_organization_id: string | null
  stord_network_id: string | null
}

export interface UpdateStordConfigRequest {
  api_key?: string
  stord_organization_id: string
  stord_network_id: string
}

export function getStordConfig() {
  return api_fetch<StordConfig>("/organization/stord-config")
}

export function updateStordConfig(body: UpdateStordConfigRequest) {
  return api_fetch<StordConfig>("/organization/stord-config", {
    method: "PUT",
    body,
  })
}
